import { Player } from "@lottiefiles/react-lottie-player"
import { GlobalStateContext } from "GlobalState"
import classNames from "classnames"
import { Column, Row } from "components/Layout"
import Loader from "components/Loader"
import PageHeader from "components/PageHeader"
import PageLoader from "containers/PageLoader"
import { AnimatePresence, motion } from "framer-motion"
import * as gamesAPI from "modules/gamesAPI"
import utils from "modules/utils"
import { createRef, useContext, useEffect, useState } from "react"
import { useAsync } from "react-use"
import css from "./DiscoverPage.module.scss"

export function DiscoverPage() {
  const { tabId, setTabId } = useContext(GlobalStateContext)
  const [isFirstRender, setIsFirstRender] = useState(true)


  const { value: tabs, loading, error } = useAsync(async () => {
    const tabs = await gamesAPI.getDiscoverTabs()

    if (!tabId) {
      setTabId(tabs[0].id)
    }

    return tabs.map(tab => ({
      ...tab,
      lottieRef: createRef(),
    }))
  }, [tabId])

  useEffect(() => {
    if (!tabId || !tabs) return

    setTimeout(() => {
      tabs.forEach(({ id, lottieRef }) => {
        const lottie = lottieRef?.current?.state?.instance
        if (!lottie) return

        if (id === tabId) {
          if (isFirstRender) {
            lottie.goToAndStop(lottie.totalFrames - 1, true)
            setIsFirstRender(false)
          } else {
            lottie.goToAndPlay(20, true)
          }
        } else {
          lottie.goToAndStop(0, true)
        }
      })
    }, 1)
  }, [tabId, tabs])

  if (loading) return <Loader />
  if (error) throw error

  return (
    <>
      <PageHeader title="Discover" settingsMenu background="large">
        <Row align="msb" padding="sm xxl xl">
          {tabs.map(({ id, name, icon, lottieRef }, i) =>
            <Column key={id} onClick={() => setTabId(id)}>
              <Player
                ref={lottieRef}
                keepLastFrame
                src={utils.fetchLottie(`/lottie/${icon}_icon.json`)}
                style={{
                  width: 66,
                  height: 66,
                }}
              />
              <div className={css.tabLabel}>
                <div
                  className={classNames(css.label, {
                    [css.selected]: tabId === id,
                  })}>{name}</div>
              </div>
            </Column>
          )}
        </Row>
      </PageHeader>

      <AnimatePresence mode="wait">
        <motion.div
          key={tabId}
          initial={{ opacity: 0, transform: "translateX(1rem)" }}
          animate={{ opacity: 1, transform: "translateX(0rem)" }}
          exit={{ opacity: 0, transform: "translateX(-1rem)" }}
          transition={{ duration: 0.25 }}
          style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
        >
          <div className={css.loaderWrapper}><PageLoader tabId={tabId} /></div>
        </motion.div>
      </AnimatePresence>
    </>
  )
}
